import defineCustomElement from '../../define-custom-element.js';

import TpSelectFilled from './tp-select-filled.js';
import TpSelectFilledLight from './tp-select-filled-light.js';
import TpSelectOutlined from './tp-select-outlined.js';

defineCustomElement('tp-select-filled', TpSelectFilled);
defineCustomElement('tp-select-filled-light', TpSelectFilledLight);
defineCustomElement('tp-select-outlined', TpSelectOutlined);

export {
  TpSelectFilled,
  TpSelectFilledLight,
  TpSelectOutlined
}
